/**
 * @fileoverview Portfolio slice — kategori filtresi ve item listesi.
 * Items API veya portfolio.js mock verisinden yüklenir.
 */

import { createSlice } from '@reduxjs/toolkit'

/**
 * @typedef {'All' | string} PortfolioCategoryFilter
 * selectedCategory: 'All' veya kategori slug (ör. tourism, my-sector)
 */

/** @type {{ selectedCategory: PortfolioCategoryFilter, items: import('../../data/portfolio').PortfolioItem[], filterCategories: { slug: string, title: string }[] }} */
const initialState = {
  selectedCategory: 'All',
  items: [],
  filterCategories: [],
}

const portfolioSlice = createSlice({
  name: 'portfolio',
  initialState,
  reducers: {
    /**
     * Aktif kategori filtresini değiştir (slug veya All).
     * @param {typeof initialState} state
     * @param {{ payload: PortfolioCategoryFilter }} action
     */
    setCategory: (state, action) => {
      state.selectedCategory = action.payload
    },
    /**
     * @param {typeof initialState} state
     * @param {{ payload: import('../../data/portfolio').PortfolioItem[] }} action
     */
    setItems: (state, action) => {
      state.items = action.payload
    },
    /**
     * Portföy listesi sayfası filtre çipleri (CMS kategori başlıkları, seçili dil).
     * @param {typeof initialState} state
     * @param {{ payload: { slug: string, title: string }[] }} action
     */
    setFilterCategories: (state, action) => {
      state.filterCategories = Array.isArray(action.payload) ? action.payload : []
    },
  },
})

export const { setCategory, setItems, setFilterCategories } = portfolioSlice.actions

export const selectSelectedCategory = (state) => state.portfolio.selectedCategory
export const selectPortfolioItems = (state) => state.portfolio.items
export const selectFilterCategories = (state) => state.portfolio.filterCategories

/**
 * @param {{ portfolio: typeof initialState }} state
 */
export const selectFilteredItems = (state) => {
  const { items, selectedCategory } = state.portfolio
  if (selectedCategory === 'All') return items

  return items.filter((item) => {
    const slugs = Array.isArray(item.category_slugs) ? item.category_slugs : []
    if (slugs.length > 0) {
      return slugs.some((s) => String(s).toLowerCase() === String(selectedCategory).toLowerCase())
    }
    if (item.sector != null && String(item.sector).trim() !== '') {
      const legacy = String(item.sector).trim()
      return legacy.toLowerCase() === String(selectedCategory).toLowerCase()
    }
    return false
  })
}

export default portfolioSlice.reducer
